<template>
    <span v-if="this.msgId && !this.isPinnedRow">
        <b-button
            @click="handleViewMessageClick"
            title="View Message"
            variant="default"
        >
            <font-awesome-icon :icon="['fas', 'eye']"></font-awesome-icon>
        </b-button>
        <b-button
            @click="handleLoginAsUserToInbox"
            title="View In Inbox"
            variant="default"
        >
            <font-awesome-icon :icon="['fas', 'circle-user']"></font-awesome-icon>
        </b-button>
        <modal
            :id="viewMessageModalId"
            :title="`AI ${this.msgType} Message`"
            @shown="onModalShown"
            ok-only
        >
            <div v-html="this.msgContent"></div>
        </modal>
    </span>
</template>

<script>
import get from 'lodash/get';
import Modal from '../../generic/modal/modal.vue';

export default {
    components: {
        Modal,
    },
    data() {
        return {
            msgId: null,
            msgContent: null,
            msgType: null,
            isPinnedRow: false,
        };
    },
    created() {
        this.msgId = this.params.data.id;
        this.msgContent = this.params.data.content;
        this.msgType = this.params.data.type;
        this.isPinnedRow = this.params.data.isPinnedRow;
        this.viewMessageModalId = `ai-report-message-${this.msgId}-modal`;
    },
    methods: {
        get,
        onModalShown() {
            this.params.api.clearFocusedCell();
        },

        handleViewMessageClick() {
            this.$bvModal.show(this.viewMessageModalId);
        },

        handleLoginAsUserToInbox() {
            const inboxUrl = `/app/chat/message/${this.msgId}/redirect`
            const subscriberId = this.params.data.subscriber;
            window.location = `/administrative/login_as_user/${subscriberId}?redirect=${inboxUrl}`;
        },
    },
};
</script>
